/**
 * Reads the PageModel JSON from the `<script type="application/json" id="page-model">`
 * element that renderAppDocument outputs.
 *
 * This replaces the old SSR hydration approach (window.__INITIAL_STATE__).
 * The JSON is inert (type="application/json" -- browsers don't execute it),
 * CSP-safe (no inline script execution), and cache-friendly (same bytes
 * for all users when the PageModel is viewer-agnostic).
 */

import type { TopicPageModel, ChapterPageModel } from "../../shared/pages/pageModels";

export type PageModel = TopicPageModel | ChapterPageModel;

export function readPageModel(): PageModel | null {
	const script = document.getElementById("page-model");
	if (!script?.textContent) return null;
	try {
		return JSON.parse(script.textContent) as PageModel;
	} catch {
		return null;
	}
}

/**
 * Returns true if the current page was server-rendered (Mode A).
 * In Mode A, [data-app-root] has child nodes (the view DOM).
 * In Mode B (SPA fallback), #root is empty.
 */
export function isSsrDirectMode(): boolean {
	const appRoot = document.querySelector<HTMLElement>("[data-app-root]");
	return Boolean(appRoot?.hasChildNodes());
}
